import CONFIG from '../../config';

const actions = {
      supplier(context, params) {
        context.commit('ADD_LOG', { request: 'supplier' });
        return new Promise((resolve, reject) => {
          this.axios
            .get(CONFIG.getEndpoint('supplier'), {
              headers:
              {
                'x-phone-number': localStorage.getItem('phone'),
                Authorization: localStorage.getItem('token')
              },
              params: params?.urlParams
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'supplier' });
              resolve(response.data);
              // context.commit('SAVE_DATA', response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'supplier' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
        });
      },
      supplierDetails(context, params) {
        context.commit('ADD_LOG', { request: 'supplierDetails' });
        return new Promise((resolve, reject) => {
          this.axios
            .get(CONFIG.getEndpoint('supplierTransaction', params.supplierId), {
              headers:
              {
                Authorization: localStorage.getItem('token')
              },
              params: params.urlParams
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'supplierDetails' });
              context.commit('SAVE_SUPPLIER_DETAILS', response.data);
              context.commit('SET_SUPPLIER_ID', response.data.supplierDetails.marketplaceId);
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'supplierDetails' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
        });
      },
      PaymentAmountPayable(context, formData) {
        context.commit('ADD_LOG', { request: 'PaymentAmountPayable' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('PaymentAmountPayable'), formData, {
              headers:
              {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
              },
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'PaymentAmountPayable' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'PaymentAmountPayable' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
          });
      },
      multiInvoicePayment(context, formData) {
        context.commit('ADD_LOG', { request: 'multiInvoicePayment' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('multiInvoicePayment'), formData, {
              headers:
              {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
              },
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'multiInvoicePayment' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'multiInvoicePayment' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
          });
      },
      processPayment(context, params) {
        context.commit('ADD_LOG', { request: 'processPayment' });
        return new Promise((resolve, reject) => {
          const reqBody = {
            paymentMethod: params.paymentMethod,
          };
          if (params.paymentMethod === 'Debit Card') {
            reqBody.transactionId = params.transactionId;
            reqBody.repaymentDTO = {
              amount: params.repaymentDTO.amount,
              nbfcPgPaymentId: params?.repaymentDTO?.nbfcPgPaymentId,
              cardInfo: {
              cardNumber: params.repaymentDTO?.cardInfo?.cardNumber || "",
              cvv: params.repaymentDTO?.cardInfo?.cvv || "",
              expiry: params.repaymentDTO?.cardInfo?.expiry || "",
              saveCard: params.repaymentDTO?.cardInfo?.saveCard,
              }
            };
          } else if (params.paymentMethod === 'Net Banking') {
            reqBody.transactionId = params.transactionId;
            reqBody.repaymentDTO = {
              amount: params.repaymentDTO.amount,
              nbfcPgPaymentId: params?.repaymentDTO?.nbfcPgPaymentId,
            };
          } else {
            reqBody.transactionId = params.transactionId;
            reqBody.repaymentDTO = {
              amount: params.repaymentDTO.amount,
              nbfcPgPaymentId: params?.repaymentDTO?.nbfcPgPaymentId,
              upiInfo: {
                vpa: params.repaymentDTO?.upiInfo?.vpa || ""
              }
            };
          }
          this.axios
            .post(CONFIG.getEndpoint('processPayment', params.paymentMethod, params.transactionId), reqBody,
              {
              headers:
              {
                Authorization: localStorage.getItem('token'),
              },
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'processPayment' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'processPayment' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
          });
      },
      verifyPaymentOtp(context, params) {
        context.commit('ADD_LOG', { request: 'verifyPaymentOtp' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('verifyPaymentOtp', params.chequeNumber, params.otp, params.transactionId), {
              chequeNumber: params.chequeNumber,
              otp: params.otp,
              transactionId: params.transactionId,
            }, {
              headers:
              {
                Authorization: localStorage.getItem('token'),
              },
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'verifyPaymentOtp' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'verifyPaymentOtp' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
          });
      },
      resendPaymentOtp(context, params) {
        context.commit('ADD_LOG', { request: 'resendPaymentOtp' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('resendPaymentOtp', params.transactionId), {
              transactionId: params.transactionId
            }, {
              headers:
              {
                Authorization: localStorage.getItem('token'),
              },
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'resendPaymentOtp' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'resendPaymentOtp' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
          });
      },
      v3ApplicationMarketplaceDocument(context, params) {
          context.commit('ADD_LOG', { request: 'v3ApplicationMarketplaceDocument' });
          return new Promise((resolve, reject) => {
            this.axios
              .patch(CONFIG.getEndpoint('v3ApplicationMarketplaceDocument', params.applicationId), params.formData, {
                headers: {
                  Authorization: localStorage.getItem('token'),
                },
                params: params.urlParams
              })
              .then((response) => {
                context.commit('REMOVE_LOG', { request: 'v3ApplicationMarketplaceDocument' });
                resolve(response.data);
              })
              .catch((err) => {
                context.commit('REMOVE_LOG', { request: 'v3ApplicationMarketplaceDocument' });
                context.dispatch('resolveError', { err })
                  .catch((resolvedError) => {
                    reject(resolvedError);
                  });
              });
          });
        },
        v2applicationMerchantOnboardingLink(context, params) {
          context.commit('ADD_LOG', { request: 'v2applicationMerchantOnboardingLink' });
          return new Promise((resolve, reject) => {
            this.axios
              .post(CONFIG.getEndpoint('v2applicationMerchantOnboardingLink'), params.postParams, {
                headers:
                {
                  Authorization: localStorage.getItem('token')
                },
                params: params.urlParams
              })
              .then((response) => {
                context.commit('REMOVE_LOG', { request: 'v2applicationMerchantOnboardingLink' });
                resolve(response.data);
              })
              .catch((err) => {
                context.commit('REMOVE_LOG', { request: 'v2applicationMerchantOnboardingLink' });
                context.dispatch('resolveError', { err })
                  .catch((resolvedError) => {
                    reject(resolvedError);
                  });
              });
          });
        },
      suppliersTransactionDetails(context, params) {
          context.commit("ADD_LOG", { request: "supplierTransactionDetails" });
          return new Promise((resolve, reject) => {
            this.axios
              .get(CONFIG.getEndpoint("suppliersTransactionDetails", params.uuid), {
                params: params.urlParams,
                headers: {
                  Authorization: localStorage.getItem("token")
                }
              })
              .then(response => {
                context.commit("REMOVE_LOG", { request: "supplierTransactionDetails" });
                resolve(response.data);
              })
              .catch(err => {
                context.commit("REMOVE_LOG", { request: "supplierTransactionDetails" });
                context.dispatch("resolveError", { err }).catch(resolvedError => {
                  reject(resolvedError);
                });
              });
          });
      },
      rePaymentDetails(context, params) {
        context.commit("ADD_LOG", { request: "rePaymentDetails" });
        return new Promise((resolve, reject) => {
          this.axios
            .get(CONFIG.getEndpoint("rePaymentDetails", params.transactionId), {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            })
            .then(response => {
              context.commit("REMOVE_LOG", { request: "rePaymentDetails" });
              resolve(response.data);
            })
            .catch(err => {
              context.commit("REMOVE_LOG", { request: "rePaymentDetails" });
              context.dispatch("resolveError", { err }).catch(resolvedError => {
                reject(resolvedError);
              });
            });
        });
      },
      validateVpa(context, params) {
        context.commit('ADD_LOG', { request: 'validateVpa' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('validateVpa'), params.postParams, {
              headers:
              {
                Authorization: localStorage.getItem('token')
              },
              params: params.urlParams
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'validateVpa' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'validateVpa' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
        });
      },
      eligibilityCheck(context, params) {
        context.commit('ADD_LOG', { request: 'eligibilityCheck' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('eligibilityCheck'), params.postParams, {
              headers:
              {
                Authorization: localStorage.getItem('token')
              },
              params: params.urlParams
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'eligibilityCheck' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'eligibilityCheck' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
        });
      },
      mpinVerify(context, params) {
        context.commit('ADD_LOG', { request: 'mpinVerify' });
        return new Promise((resolve, reject) => {
          this.axios
            .post(CONFIG.getEndpoint('mpinVerify'), params.postParams, {
              headers:
              {
                Authorization: localStorage.getItem('token')
              },
              params: params.urlParams
            })
            .then((response) => {
              context.commit('REMOVE_LOG', { request: 'mpinVerify' });
              resolve(response.data);
            })
            .catch((err) => {
              context.commit('REMOVE_LOG', { request: 'mpinVerify' });
              context.dispatch('resolveError', { err })
                .catch((resolvedError) => {
                  reject(resolvedError);
                });
            });
        });
      },
};

export default actions;
